exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "footer {\n  background: black;\n  position: static;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  flex-direction: row;\n  color: white;\n  justify-content: space-between;\n  padding: 10px 20px;\n  margin-top: 50px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/footer/Footer.scss
// module id = 149
// module chunks = 0